import type {
  GetNotificationPreferencesResponse,
  UpdateNotificationPreferencesRequest,
} from "src/shared/api-types/user/notification-preferences.dto";

import { typedRequest } from "./typedRequest";

/** The caller's preferences: only the kinds that can reach them, each with the stored value or the default. */
export const getNotificationPreferences = async (): Promise<GetNotificationPreferencesResponse> =>
  typedRequest.get("/user/me/notification-preferences");

/** Upserts the listed kinds and returns the full list. */
export const updateNotificationPreferences = async (
  body: UpdateNotificationPreferencesRequest,
): Promise<GetNotificationPreferencesResponse> => typedRequest.put({ url: "/user/me/notification-preferences", body });
